export default {
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowHtml: true,
  allowAlignment: true,
  allowAnchorEditorHeader: true
};